export default "__VITE_ASSET__Gc5Fl46L__"